import axios from "axios";

import {API_MOBILE_BFF, COMMON_HEADER_CONFIG} from "../config";

class CmsServiceInstance {
  constructor(baseURL) {
    this.token = localStorage.getItem("accessToken");
    this.baseURL = baseURL;
    this.config = {
      method: "get",
      headers: {
        ...COMMON_HEADER_CONFIG,
        Authorization: `Bearer ${this.token}`
      }
    };
  }

  /**
   * @description Get page cms
   * @returns  Promise
   */
  getPageCms = () =>
    new Promise((resolve, reject) => {
      const config = {
        ...this.config,
        url: `${this.baseURL}/ca-component/metadata/screen`
      };

      return axios(config)
        .then((response) => {
          if (response.data.data) {
            resolve(response.data.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getContentPage = (query) =>
    new Promise((resolve, reject) => {
      const config = {
        ...this.config,
        url: `${this.baseURL}/ca-component/metadata?screen=${query.screen}`
        // params: {
        //   ...query
        // }
      };

      return axios(config)
        .then((response) => {
          if (response.data.data) {
            resolve(response.data.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  createNewPage = (data) =>
    new Promise((resolve, reject) => {
      const config = {
        ...this.config,
        method: "post",
        url: `${this.baseURL}/ca-component/metadata`,
        data
      };

      return axios(config)
        .then((response) => {
          if (response.data.data) {
            resolve(response.data.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  /**
   * @param {object} params data update
   * @returns Promise
   */
  updatePage = (data) =>
    new Promise((resolve, reject) => {
      const config = {
        ...this.config,
        method: "put",
        url: `${this.baseURL}/ca-component/metadata`,
        data
      };

      return axios(config)
        .then((response) => {
          if (response.data.data) {
            resolve(response.data.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  updateContentOfPage = (data) =>
    new Promise((resolve, reject) => {
      const config = {
        ...this.config,
        method: "put",
        url: `${this.baseURL}/ca-component/metadata/${data?.id}`,
        data
      };

      return axios(config)
        .then((response) => {
          if (response.data.data && response.data.message === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.message);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  /**
   *
   * @param {*} id page id
   * @returns Promise
   */
  removeContentOfPage = (id) =>
    new Promise((resolve, reject) => {
      const config = {
        ...this.config,
        method: "delete",
        url: `${this.baseURL}/ca-component/metadata/${id}`
      };

      return axios(config)
        .then((response) => {
          if (response.data) {
            resolve(id);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
}

const cmsService = new CmsServiceInstance(API_MOBILE_BFF);

export default cmsService;
